
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const MagnifyingGlassIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M43 11.998C25.8792 11.998 12 25.8772 12 42.998C12 60.1189 25.8792 73.998 43 73.998C50.2993 73.998 57.0093 71.4753 62.3058 67.2542L78.0251 82.9734C79.392 84.3403 81.608 84.3403 82.9749 82.9734C84.3417 81.6066 84.3417 79.3905 82.9749 78.0237L67.2556 62.3045C71.4771 57.0079 74 50.2976 74 42.998C74 25.8772 60.1208 11.998 43 11.998ZM19 42.998C19 29.7432 29.7452 18.998 43 18.998C56.2548 18.998 67 29.7432 67 42.998C67 56.2529 56.2548 66.998 43 66.998C29.7452 66.998 19 56.2529 19 42.998Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M70.5 42.998C70.5 58.1859 58.1878 70.498 43 70.498C27.8122 70.498 15.5 58.1859 15.5 42.998C15.5 27.8102 27.8122 15.498 43 15.498C58.1878 15.498 70.5 27.8102 70.5 42.998Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M43 11.998C25.8792 11.998 12 25.8772 12 42.998C12 60.1189 25.8792 73.998 43 73.998C50.2993 73.998 57.0093 71.4753 62.3058 67.2542L78.0251 82.9734C79.392 84.3403 81.608 84.3403 82.9749 82.9734C84.3417 81.6066 84.3417 79.3905 82.9749 78.0237L67.2556 62.3045C71.4771 57.0079 74 50.2976 74 42.998C74 25.8772 60.1208 11.998 43 11.998ZM19 42.998C19 29.7432 29.7452 18.998 43 18.998C56.2548 18.998 67 29.7432 67 42.998C67 56.2529 56.2548 66.998 43 66.998C29.7452 66.998 19 56.2529 19 42.998Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M70.5 42.998C70.5 58.1859 58.1878 70.498 43 70.498C27.8122 70.498 15.5 58.1859 15.5 42.998C15.5 27.8102 27.8122 15.498 43 15.498C58.1878 15.498 70.5 27.8102 70.5 42.998Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
